import React from 'react';

function ProgressBar(props) {

  const baseStyle = {
    backgroundColor: '#edebed',
    height: '32px',
    boxShadow: '2px 2px 6px #fff',
    width: '0%'
  };

  props.progress && 
    (baseStyle.width = props.progress + '%');

  return (
    <div style={baseStyle}></div>
  );
}

export default ProgressBar;